<template>
  <modal name="add-filter"
         class="add-filter"
         width="350px"
         height="auto"
         transition="modal-fade"
         @before-open="beforeOpen">
    <div class="add-filter__wrap">
      <div class="add-filter__title">
        {{ titleText }}
      </div>
      <form action="" class="add-filter__form" @submit.prevent="onSubmit">
        <div class="add-filter__form-input" v-if="type !== $options.TYPES.delete">
          <BaseInput
            v-model="filterName"
            :label="$t('filterName')"
            :invalid="$v.filterName.$error"
            :error="filterNameError"
            @blur="$v.filterName.$touch"
          />
        </div>
        <template v-else>
          <p class="add-filter__form-delete">
            Do you really want to remove the filter <strong>{{ filterName }}</strong>?
          </p>
        </template>
        <div class="add-filter__form-actions">
          <BaseButton oval type="submit" :loading="isLoadingFilters" :disabled="$v.$invalid">
            {{ buttonText }}
          </BaseButton>
        </div>
      </form>
    </div>
  </modal>
</template>
<script>
import { maxLength, required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
const NAME_MAX_LENGTH = 30
const TYPES = {
  update: 'update',
  create: 'create',
  delete: 'delete'
}

export default {
  name: 'add-filter',
  TYPES,
  data () {
    return {
      filterName: '',
      selectedId: null,
      type: TYPES.create
    }
  },
  validations: {
    filterName: {
      required,
      maxLength: maxLength(NAME_MAX_LENGTH)
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      isLoadingFilters: 'filter/isLoadingFilters'
    }),
    filterNameError () {
      if (!this.$v.filterName.maxLength) {
        return `${this.$t('errorMaxLength_begin')} ${NAME_MAX_LENGTH} ${this.$t('errorLength_end')}`
      }
      return this.$t('errorEmptyField')
    },
    titleText () {
      return this.type === TYPES.create ? this.$t('createNewFilter') : this.type === TYPES.update ? this.$t('updateFilterName') : this.$t('deleteFilter')
    },
    buttonText () {
      return this.type === TYPES.create ? this.$t('buttonCreate') : this.type === TYPES.update ? this.$t('buttonUpdate') : this.$t('buttonDelete')
    }
  },
  methods: {
    ...mapActions({
      createFilter: 'filter/createFilter',
      deleteFilter: 'filter/deleteFilter',
      updateFilter: 'filter/updateFilter'
    }),
    beforeOpen ({ params: { name, id, type } }) {
      this.type = type
      this.filterName = name || ''
      this.selectedId = id || null
      this.$v.$reset()
    },
    async onSubmit () {
      this.$v.$touch()
      if (this.isLoadingFilters || this.$v.$invalid) return
      switch (this.type) {
        case TYPES.create: {
          await this.createFilter({
            name: this.filterName,
            userId: this.user.id
          })
          break
        }
        case TYPES.update: {
          await this.updateFilter({
            name: this.filterName,
            id: this.selectedId
          })
          break
        }
        case TYPES.delete: {
          await this.deleteFilter({
            id: this.selectedId
          })
          break
        }
        default: {}
      }

      this.$modal.hide('add-filter')
    }
  }
}
</script>
<style lang="scss">
.add-filter{
  &__title{
    color: $green;
    font-size: 20px;
    text-align: center;
    margin-bottom: 15px;
    font-weight: 500;
  }
  &__wrap{
    padding: 15px;
  }
  &__form{
    padding-bottom: 10px;
    &-actions{
      display: flex;
      justify-content: center;
    }
    &-input{

    }
    &-delete{
      padding: 10px;
      margin-bottom: 10px;
    }
  }
}
</style>
